import types from '../actionTypes';

export const deleteInfoCategoryRequest = id => ({
    type: types.DELETE_INFO_CATEGORY_REQUEST,
    meta: {
        id,
    },
});

export const deleteInfoCategoryRequestCompleted = id => ({
    type: types.DELETE_INFO_CATEGORY_REQUEST_COMPLETED,
    meta: {
        id,
    },
});

export const deleteInfoRequest = (id, categoryId) => ({
    type: types.DELETE_INFO_REQUEST,
    meta: {
        id,
        categoryId,
    },
});

export const deleteInfoRequestCompleted = id => ({
    type: types.DELETE_INFO_REQUEST_COMPLETED,
    meta: {
        id,
    },
});
